// extracted by mini-css-extract-plugin
module.exports = {"section":"CreateApplication_section__2cMGb","min-h":"CreateApplication_min-h__1HVol","loading":"CreateApplication_loading__DsKcX"};